// extracted by mini-css-extract-plugin
export default {"root__wrapper":"style-module__root__wrapper___nPD_X","root__more":"style-module__root__more___C24oA"};
    if(module.hot) {
      // 1697460473072
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  